<template>
  <div class="personcenter">
    <div class="wall">
      <div v-if="isShow">
        <div class="loginInfo-block">
          <div @click="goSM('myinfo')">
            <!-- <img class="icon-avater" src="../images/avater_default.png" /> -->
            <img  class="icon-avater" :src="img"  />
            <div class="info-block">
              <div class="name">{{ this.userInfo.name }}</div>
              <div class="phone">{{ this.userInfo.phone }}</div>
            </div>
          </div>
          <div class="right-button">
            <!-- <div class="rz-button" @click="goBD()">重新绑定</div> -->
            <div
              class="rz-button"
              v-if="userInfo.is_smrz != 'yes'"
              @click="goSM('myinfoupdate')"
            >
              未实名认证
            </div>
            <div class="rz-button" v-else @click="goSM('myinfo')">
              已实名认证
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isShow" class="login-block">
        <router-link
          class="user-operate"
          :to="{ name: 'login', query: { back: true } }"
        >
          <span class="btn-login">请登录</span>
        </router-link>
        <!-- <router-link
          class="user-operate"
          :to="{ name: 'registered', query: {} }"
        >
          <span class="btn-register">注册</span>
        </router-link> -->
      </div>
    </div>

    <div class="line-block">
      <div class="icon-block" @click="goPage('browsinghistory')">
        <div>
          <img src="../images/icon/5.png" alt="" />
        </div>
        <div>浏览历史</div>
      </div>
      <div class="icon-block" @click="goPage('checkingmanagement')">
        <div>
          <img src="../images/icon/6.png" alt="" />
        </div>
        <div>看房管理</div>
      </div>
      <div class="icon-block" @click="goPage('contractmanagement')">
        <div>
          <img src="../images/icon/7.png" alt="" />
        </div>
        <div>合同订单</div>
      </div>
      <div class="icon-block">
        <div>
          <img src="../images/icon/8.png" alt="" />
        </div>
        <div>我的顾问</div>
      </div>
    </div>

    <!-- <ul class="user-nav">
      <li v-for="nav in navList" @click="skip(nav)" v-if="isShowNav(nav)">
        <span
          class="nav-icon"
          :style="{ backgroundPositionY: -0.3 * nav.iconIndex + 'rem' }"
        ></span>
        <div class="nav">
          {{ nav.title }}
        </div>
      </li>
    </ul> -->

    <!-- <ul class="user-nav">
      <li v-for="nav in bottomList" @click="skip(nav)" v-if="isShowNav(nav)">
        <span
          class="nav-icon"
          :style="{ backgroundPositionY: -0.3 * nav.iconIndex + 'rem' }"
        ></span>
        <div class="nav">
          {{ nav.title }}
        </div>
      </li>
    </ul> -->

    <div class="myhouse">
      <div class="house-title">我的房子</div>
      <div class="house-body">
        <div class="hd-icon">
          <img class="hd-icon-img" src="../images/icon/13.png" alt="" />
        </div>
        <div class="hd-text" @click="goRenWu">点击添加我的房子</div>
      </div>
    </div>

    <div
      class="myhouse"
      style="margin-top: 0.3rem !important"
      v-if="DQ_list.length > 0"
      @click="gopage_ht(DQ_list[0])"
    >
      <div class="house-title">待办订单</div>

      <div class="db-body">
        <div class="line">
          <div class="line-pram">合同类型</div>
          <div class="line-text">
            <div v-if="DQ_list[0].type == 'mmrw'">买卖合同</div>
            <div v-if="DQ_list[0].type == 'mmls_rw'">买卖两书</div>
            <div v-if="DQ_list[0].type == 'mmjy'">买卖物业交验</div>
            <div v-if="DQ_list[0].type == 'zulin_new'">租赁合同</div>
            <div v-if="DQ_list[0].type == 'zlls'">租赁两书</div>
            <div v-if="DQ_list[0].type == 'zljy'">租赁物业交验</div>
            <div v-if="DQ_list[0].type == 'shangye'">商业租赁合同</div>
          </div>
        </div>
        <div class="line">
          <div class="line-pram">合同编号</div>
          <div class="line-text">{{ DQ_list[0].htbh }}</div>
        </div>
        <!-- <div class="line">
          <div class="line-pram">物业地址</div>
          <div class="line-text">
            {{ DQ_list[0].adress }}
          </div>
        </div>
        <div class="line">
          <div class="line-pram">户型</div>
          <div class="line-text">{{ DQ_list[0].huxing }}</div>
        </div>

        <div class="line">
          <div class="line-pram">面积</div>
          <div class="line-text">{{ DQ_list[0].mianji }}m²</div>
        </div>

        <div class="line">
          <div class="line-pram">价格</div>
          <div class="line-text fontcolor">{{ DQ_list[0].jiage }}万元</div>
        </div>

        <div class="line">
          <div class="line-pram">签约时间</div>
          <div class="line-text">{{ DQ_list[0].qyrq }}</div>
        </div> -->
      </div>
    </div>

    <div class="otherservice">
      <div class="house-title">其他服务</div>
      <div class="service-list">
        <div>
          <div>
            <img class="icon-img" src="../images/icon/9.png" alt="" />
          </div>
          <div class="icon-text">我的问答</div>
        </div>
        <div>
          <div>
            <img class="icon-img" src="../images/icon/10.png" alt="" />
          </div>
          <div class="icon-text">我的点评</div>
        </div>
        <div>
          <div>
            <img class="icon-img" src="../images/icon/11.png" alt="" />
          </div>
          <div class="icon-text">官方客服</div>
        </div>
        <div>
          <div>
            <img class="icon-img" src="../images/icon/12.png" alt="" />
          </div>
          <div class="icon-text">用户反馈</div>
        </div>
      </div>
    </div>

    <!-- <div class="bottom ">
      <router-link
        v-if="isShow"
        class=""
        :to="{ name: 'login', query: { back: true } }"
        >退出登录</router-link
      >
    </div> -->

    <div class="bottom" v-if="isShow">
      <div @click="loginout()" class="btn-exit">退出登录</div>
    </div>
  </div>
</template>
<script>
import actions from "../common/test.js";
import util from "../common/util.js";
import { Dialog } from "vant";
export default {
  data() {
    return {
      isShow: false,
      navList: [
        {
          id: 0,
          title: "我关注的二手房",
          iconIndex: 0,
          show: true,
          isLogin: true,
          type: "2",
          name: "list",
          query: { type: "guanzhu" },
        },
        {
          id: 1,
          title: "我关注的新房",
          iconIndex: 0,
          show: true,
          isLogin: true,
          type: "1",
          name: "list",
          query: { type: "guanzhu" },
        },
        {
          id: 2,
          title: "我关注的租房",
          iconIndex: 0,
          show: true,
          isLogin: true,
          type: "3",
          name: "list",
          query: { type: "guanzhu" },
        },
        {
          id: 11,
          title: "我看过的房源",
          iconIndex: 0,
          show: true,
          isLogin: true,
          type: "",
          name: "renwumydakalist",
          query: {},
        },
        {
          id: 3,
          title: "我打卡的二手房",
          iconIndex: 3,
          show: false,
          isLogin: true,
          type: "2",
          name: "mycheckin",
          query: {},
        },
        {
          id: 5,
          title: "我打卡的租房",
          iconIndex: 3,
          show: false,
          isLogin: true,
          type: "3",
          name: "mycheckin",
          query: {},
        },
        {
          id: 6,
          title: "我的二手房",
          iconIndex: 1,
          show: false,
          isLogin: true,
          type: "2",
          name: "myhouse",
          query: {},
        },
        {
          id: 7,
          title: "我的租房",
          iconIndex: 1,
          show: false,
          isLogin: true,
          type: "3",
          name: "myhouse",
          query: {},
        },
        {
          id: 8,
          title: "我的客源",
          iconIndex: 1,
          show: false,
          isLogin: true,
          type: "3",
          name: "custommanager",
          query: {},
        },
        {
          id: 9,
          title: "我的合同列表",
          iconIndex: 1,
          show: false,
          isLogin: true,
          type: "",
          name: "contractList",
          query: {},
        },
        {
          id: 10,
          title: "我的两书",
          iconIndex: 1,
          show: false,
          isLogin: true,
          type: "",
          name: "liangshucontractList",
          query: {},
        },
      ],
      bottomList: [
        {
          id: 0,
          title: "我的问答",
          iconIndex: 0,
          show: true,
          isLogin: true,
          type: "2",
          name: "list",
          query: { type: "guanzhu" },
        },

        {
          id: 0,
          title: "我的点评",
          iconIndex: 0,
          show: true,
          isLogin: true,
          type: "2",
          name: "list",
          query: { type: "guanzhu" },
        },
        {
          id: 0,
          title: "官方客服",
          iconIndex: 0,
          show: true,
          isLogin: true,
          type: "2",
          name: "list",
          query: { type: "guanzhu" },
        },
        {
          id: 0,
          title: "用户反馈",
          iconIndex: 0,
          show: true,
          isLogin: true,
          type: "2",
          name: "list",
          query: { type: "guanzhu" },
        },
      ],
      name: util.getLocalStorage("xingming"),
      phone: util.getLocalStorage("phone"),
      img: util.getLocalStorage("touxiang"),
      userInfo: {},
      DQ_list: [],
    };
  },
  created() {
    this.$store.commit("changeTitle", "我的");
    util.hideLoading();
  },
  methods: {
    isShowNav(nav) {
      if (
        [3, 5, 6, 7, 8, 9, 10].includes(nav.id) &&
        this.$store.state.isManager
      ) {
        return true;
      }
      return nav.show;
    },
    skip(nav) {
      if (!util.getLocalStorage("phone") && nav.isLogin) {
        this.$router.push({ name: "login", query: { back: true } });
        return;
      }
      this.$router.push({
        name: nav.name,
        params: { type: nav.type },
        query: nav.query,
      });
    },
    goPage(url_name) {
      console.log(url_name);
      this.$router.push({
        name: url_name,
      });
    },
    goSM(url_name) {
      this.$router.push({
        name: url_name,
        query: { type: this.userInfo.is_smrz != "yes" ? "false" : "true" },
      });
    },
    goSMDEMO(url_name) {
      this.$router.push({
        name: url_name,
        query: { type: "false" },
      });
    },
    //获得用户信息
    getuser_info() {
      let data = {
        gzhid: util.getLocalStorage("openid"),
        //gzhid:'ovgmM0756koHNWHF8vDXJXQA9kqE'
      };
      actions.getuser_info(data).then((res) => {
        console.log(res);
        if (res.is_success == "yes") {
          let length = res.content.length - 1;
          this.userInfo = res.content[length];
          if (res.content.length!=0 && this.userInfo.phone != undefined && this.userInfo.phone != "") {
            util.setLocalStorage("phone", this.userInfo.phone || "");
            util.setLocalStorage("name", this.userInfo.xingming);
            this.isShow = true;
          } else {
            this.isShow = false;
          }
        }
      });
    },
    goBD() {
      this.$router.push({
        name: "rebind",
      });
    },
    //获得是否有订单
    get_dq_list() {
      let data = {
        gzhid: util.getLocalStorage("openid"),
      };
      actions.contract_DQ(data).then((res) => {
        this.DQ_list = res.content;
      });
    },
    //跳转合同页
    gopage_ht(data) {
      this.$router.push({
        name: "tobesigned",
        query: data,
      });
    },

    //退出登录
    loginout() {
      let that = this;
      Dialog.confirm({
        title: "确定退出",
        message:
          "退出登录会将您的公众号解绑，您的账号信息将不显示，确定退出么？",
      })
        .then(() => {
          // on confirm
          let data = {
            gzhid: util.getLocalStorage("openid"),
          };
          actions.login_out(data).then((res) => {
            console.log(res);
            if (res.is_success == "yes") {
              that.getuser_info();
              that.get_dq_list();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    goRenWu() {
      this.$router.push({ name: "renwufwdaka" });
    }
  },
  mounted() {
    this.getuser_info();
    this.get_dq_list();
  },
};
</script>

<style lang="scss">
.personcenter {
  color: #333333;
  padding-bottom: 1.3rem;
  min-height: calc(100vh);
  .wall {
    position: relative;
    height: 1.7rem;
    // background-image: url(../images/person-bg-head.png);
    background-size: 100% auto;
    background-position: left top;
    padding-top: 0.43rem;
    background: #ecb94c;
  }
  .icon-avater {
    display: block;
    margin: 0rem 0.45rem;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 1.2rem;
  }
  .user-operate {
    display: inline-block !important;
    padding-top: 0.4rem;
    display: flex;
    justify-content: center;
  }
  .btn-login,
  .btn-register {
    display: block;
    width: 3.78rem;
    height: 0.74rem;
    line-height: 0.74rem;
    text-align: center;
    border: 1px solid #fff;
    font-size: 0.3rem;
    color: #fff;
    margin: 0 0.15rem;
  }
  .bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.3rem;
    background-color: #f5f5f5;
    .btn-exit {
      display: block;
      height: 0.7rem;
      line-height: 0.7rem;
      text-align: center;
      border: 1px solid #e22626;
      font-size: 0.3rem;
      color: #e22626;
      background-color: #fff;
    }
  }

  ul.user-nav {
    position: relative;
    // border-top: 1px solid #f2f2f2;
    // border-bottom: 1px solid #f2f2f2;
    background-color: #fff;
    padding: 0;
    margin: 0.16rem 0 0;
    li {
      display: flex;
      height: 1rem;
      align-items: center;
    }
    li:last-child {
      .nav {
        border-bottom: none;
      }
    }
    .nav-icon {
      display: block;
      width: 1rem;
      height: 0.3rem;
      background-image: url(../images/user-nav.png);
      background-repeat: no-repeat;
      background-size: 0.3rem auto;
      background-position-x: center;
      background-position-y: 0;
      font-size: 0.3rem;
    }
    .nav {
      display: flex;
      flex: 1;
      line-height: 1rem;
      border-bottom: 1px solid #f2f2f2;
      align-items: center;
      background-image: url(../images/arrow-right-1.png);
      background-size: 0.3rem auto;
      background-repeat: no-repeat;
      background-position: center right 0.3rem;
    }
  }
  .info-block {
    position: absolute;
    left: 2rem;
    top: 0.6rem;
    .name,
    .phone {
      color: #333333;
      font-size: 0.32rem;
      line-height: 0.45rem;
    }
  }
  .line-block {
    height: 2.1rem;
    background: #ecb94c;
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    .icon-block {
      font-size: 0.23rem;
      color: #222;
      img {
        width: 0.5rem;
        margin-bottom: 0.23rem;
      }
    }
  }
  .myhouse {
    margin: 0 auto;
    width: 6.9rem;
    height: 2.32rem;
    background: #ffffff;
    border-radius: 0.1rem;
    position: relative;
    padding: 0.3rem 0.23rem;
    top: -0.3rem;
    .house-title {
      font-size: 0.26rem;
      font-weight: 600;
    }
    .house-body {
      text-align: center;
      .hd-icon-img {
        width: 0.96rem;
        height: 0.96rem;
      }
    }
    .hd-text {
      margin-top: 0.14rem;
      font-size: 0.24rem;
      color: #8b8b8b;
    }
  }
  .otherservice {
    margin: 0 auto;
    width: 6.9rem;
    height: 2rem;
    background: #ffffff;
    border-radius: 0.1rem;
    position: relative;
    padding: 0.3rem 0.23rem;
    top: 0rem;
    .house-title {
      font-size: 0.26rem;
      font-weight: 600;
      margin-bottom: 0.3rem;
    }
    .service-list {
      display: flex;
      justify-content: space-between;
      text-align: center;

      .icon-img {
        width: 0.6rem;
        height: 0.6rem;
      }
      .icon-text {
        font-size: 0.24rem;
        color: #343434;
      }
    }
  }
  .login-block {
    text-align: center;
  }
}
.loginInfo-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.rz-button {
  font-size: 0.22rem;
  padding: 0.07rem 0.14rem;
  background: #cda246;
  border-radius: 0.2rem;
  margin-right: 0.3rem;
}
.right-button {
  display: flex;
}
.db-body {
  padding-bottom: 0.2rem;
  // border-bottom: 0.01rem solid #eeeeee;
  .line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.24rem;
    margin-top: 0.24rem;
    line-height: 0.36rem;
    padding: 0 0.2rem;
    .line-pram {
      color: #747474;
      width: 1.5rem;
    }
    .line-text {
      width: 3.67rem;
      text-align: right;
    }
  }
  .y-color {
    color: #ecb94c;
  }
}
</style>
